import { FloatingFormItem, InputDate } from '@/components/_common';
import { Col, Divider, Row, Typography } from 'antd';
import React from 'react';

const FilterByDatesFields: React.FC = () => {
  return (
    <>
      <Typography.Title level={4} style={{ margin: 0 }}>
        Pesquisar por datas
      </Typography.Title>

      <Divider style={{ margin: 0, marginBottom: 24 }} />

      <Row gutter={[12, 12]}>
        <Col span={24} md={12}>
          <FloatingFormItem label="Data de Vencimento de" name="initialDueDate">
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem label="Até" name="finalDueDate">
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem label="Data de Pagamento de" name="initialPayDate">
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem label="Até" name="finalPayDate">
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            label="Data de Emissão de"
            name="initialEmissionDate"
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem label="Até" name="finalEmissionDate">
            <InputDate />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
};

export default FilterByDatesFields;
